const LANGUAGE = 'LANGUAGE'
const REMOVE_USER = 'REMOVE_USER'
const ALL_USERS = 'ALL_USERS'
const LOGIN_USER = 'LOGIN_USER'
const  USER_FAQ = ' USER_FAQ'
const  CLANIC_DOCTOR_SERVICES = ' CLANIC_DOCTOR_SERVICES'
const  ALL_DOCTORS_USERS = ' ALL_DOCTORS_USERS'
const  ALL_ROOMS = ' ALL_ROOMS'
const  ALL_CONTACT_FORMS = ' ALL_CONTACT_FORMS'


export {
    LANGUAGE,
    LOGIN_USER,
    REMOVE_USER,
    ALL_USERS,
    USER_FAQ,
    ALL_DOCTORS_USERS,
    ALL_ROOMS,
    CLANIC_DOCTOR_SERVICES,
    ALL_CONTACT_FORMS
}
